export default __webpack_public_path__ + "static/media/gallery - draught of living death_00.df3189b8.jpg";